import Vue from 'vue';
import StoryList from 'components/StoryList';
import StoryView from 'components/StoryView';
import StoryChapter from 'components/StoryChapter';
import App from './App';

import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.use(VueRouter);

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';

/* eslint-disable no-new */
const router = new VueRouter();
router.map({
  '/list': {
    component: StoryList,
  },
  '/view/:story': {
    name: 'read',
    component: StoryView,
    subRoutes: {
      '/:chapter': {
        name: 'read-chapter',
        component: StoryChapter,
      },
    },
  },
});
router.redirect({
  '*': '/list',
  '/view/:story': '/view/:story/1',
});
router.start(App, '#app');



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/